/** 与后端 composeApiModelId 一致 */
export function composeApiModelId(modelCode: string, modelVersion?: string | null): string {
  const code = modelCode.trim();
  const version = modelVersion?.trim();
  if (!version) return code;
  return `${code}-${version}`;
}
